import MilestonesList from './components/MilestonesList';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import values from 'lodash/values';
import get from 'lodash/get';
import { connect } from 'react-redux';

import {
    loadMilestones,
    updateMilestone
} from '../../shared/redux/entities/actions'

function mapStateToProps(state,props){
  return {
    milestones:values(get(state,['entities','milestones'],{})).filter((m) => (m.milestoneType === 'message' || m.milestoneType === 'feature'))
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
      loadMilestones,
      updateMilestone
  },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(MilestonesList));



// WEBPACK FOOTER //
// ./src/routes/MilestonesList/index.js